import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import * as Globals from '../globals';
declare var $: any;
const url = Globals.serviceUrl;

@Component({
  selector: 'app-push-ntpn',
  templateUrl: './push-ntpn.component.html',
  styleUrls: ['./push-ntpn.component.css']
})
export class PushNtpnComponent implements OnInit {

  tab: number = 1;
  data: any;
  payments: any = {};
  kodeBilling: string;
  kodeBilling2: string;
  idStatus: string;
  param: any;
  loading: boolean;
  p: number = 1;
  userProfile: any;
  bids: any;
  eSBN: any;
  mpnNotif: any;
  authMenu: any;
  source: string ='';
  tblShow: boolean = false;
  tblShow2: boolean = false;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private route: ActivatedRoute, private router: Router) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
    this.userProfile = { PARENT_GROUP_ID: null };
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/pushNtpn/0') {
          this.tab = 1;
          this.router.navigate(['/pushNtpn/1']);
        }
      };
    });
  }

  ngOnInit() {
    let id = +this.route.snapshot.params['id'];
    if (id == 0) {
      this.router.navigate(['/pushNtpn/1']);
    }
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
    }
  }

  getBids() {
    this.loading = true;
    this.clearData();
    if (this.kodeBilling2 == undefined || this.kodeBilling2 == '') {
      this.toastr.error('Kode Billing harus di isi. ');
    }
    else {
      this.http.get(url + 'ritel/getBids?kodeBilling=' + this.kodeBilling2 + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.data = res.json();
          this.bids = this.data.Model;
          this.tblShow2 = true;
          this.idStatus = this.bids.IdStatus;
          this.toastr.success('Data Pemesanan ditemukan di eSBN. ');
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.tblShow = false;
          this.loading = false;
        });
    }
  }

  getESBN() {
    this.loading = true;
    this.clearData();
    if (this.kodeBilling == undefined || this.kodeBilling == '') {
      this.toastr.error('Kode Billing harus di isi. ');
    }
    else {
      this.http.get(url + 'ritel/getESBN?kodeBilling=' + this.kodeBilling + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.data = res.json();
          this.eSBN = this.data.Model;
          this.tblShow = true;
          this.source = 'eSBN';
          this.toastr.success('Data Pembayaran ditemukan di eSBN. ');
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.tblShow = false;
          this.loading = false;
        });
    }
  }

  getSimponi() {
    this.loading = true;
    this.clearData();
    if (this.kodeBilling == undefined || this.kodeBilling == '') {
      this.toastr.error('Kode Billing harus di isi. ');
    }
    else {
      this.http.get(url + 'ritel/getSimponi?kodeBilling=' + this.kodeBilling + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.data = res.json();
          this.eSBN = this.data.Model;
          this.tblShow = true;
          if (this.data.Code == 170) {
            this.source = 'eSBN';
            this.toastr.success('Data Pembayaran ditemukan di eSBN. ');
          }
          else{
            this.source = 'Simponi';
            this.toastr.success('Data Pembayaran ditemukan di Simponi. ');
          }
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.tblShow = false;
          this.loading = false;
        });
    }
  }

  sendEmail(trxId : string) {
    this.loading = true;
    this.clearData();
    if (this.kodeBilling == undefined || this.kodeBilling == '') {
      this.toastr.error('Kode Billing harus di isi. ');
    }
    else {
      this.http.get(url + 'ritel/sendEmail?kodeBilling=' + this.kodeBilling + '&trxId=' + trxId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.data = res.json();
          this.eSBN = this.data.Model;
          // this.source = 'eSBN';
          this.toastr.success('Email berhasil dikirim. ');
          this.loading = false;
          this.getESBN();
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.tblShow = false;
          this.loading = false;
        });
    }
  }

  // getMpn() {
  //   this.loading = true;
  //   this.clearData();
  //   if (this.kodeBilling == undefined || this.kodeBilling == '') {
  //     this.toastr.error('Kode Billing harus di isi. ');
  //   }
  //   else {
  //     this.http.get(url + 'ritel/getMPNBillNotif?kodeBilling=' + this.kodeBilling + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
  //       .subscribe((res: Response) => {
  //         this.data = res.json();
  //         this.eSBN = this.data.Model;
  //         this.tblShow = true;
  //         if (this.data.Code == 170) {
  //           this.source = 'eSBN';
  //           this.toastr.success('Data Pembayaran ditemukan di eSBN. ');
  //         }
  //         else{
  //           this.source = 'MPN';
  //           this.toastr.success('Data Pembayaran ditemukan. ');
  //         }
  //         this.loading = false;
  //       }, err => {
  //         console.log(err);
  //         this.toastr.error(Globals.errorMessage(err));
  //         this.tblShow = false;
  //         this.loading = false;
  //       });
  //   }
  // }

  getMpn() {
    this.loading = true;
    this.clearData();
    if (this.kodeBilling == undefined || this.kodeBilling == '') {
      this.toastr.error('Kode Billing harus di isi. ');
    }
    else {
      this.http.get(url + 'ritel/getMPN?kodeBilling=' + this.kodeBilling + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.data = res.json();
          this.eSBN = this.data.Model.payments;
          this.mpnNotif = this.data.Model.mpnBillingNotif;
          this.tblShow = true;
          if (this.data.Code == 170) {
            this.source = 'eSBN';
            this.toastr.success('Data Pembayaran ditemukan di eSBN. ');
          }
          else{
            this.source = 'MPN';
            this.toastr.success('Data Pembayaran ditemukan. ');
          }
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.tblShow = false;
          this.loading = false;
        });
    }
  }

  pushNTPN() {
    this.loading = true;
    //console.log(this.mpnNotif);
    this.eSBN.Kode_Billing_Simponi = this.kodeBilling;
    this.http.post(url + 'ritel/pushNtpn', this.mpnNotif, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.data = res.json();
        this.toastr.success('Data Pembayaran berhasil ditambahkan. ');
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  pushUnpaid() {
    this.loading = true;
    //let billCode: string = this.kodeBilling;
    this.http.post(url + 'ritel/pushUnpaid', this.bids, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.data = res.json();
        this.toastr.success('Data Pembayaran berhasil ditambahkan. ');
        this.getBids();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  clearData(){
    this.eSBN = {};
    this.source = '';
  }

  reset(){
    this.eSBN = {};
    this.source = '';
    this.tblShow = false;
    this.kodeBilling = '';
    this.tblShow2 = false;
    this.kodeBilling2 = '';
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/push-ntpn/push-ntpn.component.ts